import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DocumentoEditarService {

  private editarDocumentoSubject =
    new BehaviorSubject<number | null>(null);

  editarDocumento$ =
    this.editarDocumentoSubject.asObservable();

  editarDocumento(idArchivo: number) {
    this.editarDocumentoSubject.next(idArchivo);
  }
}